import { render, staticRenderFns } from "./TicketDetail.vue?vue&type=template&id=297eaffb&"
import script from "./TicketDetail.vue?vue&type=script&lang=js&"
export * from "./TicketDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('297eaffb')) {
      api.createRecord('297eaffb', component.options)
    } else {
      api.reload('297eaffb', component.options)
    }
    module.hot.accept("./TicketDetail.vue?vue&type=template&id=297eaffb&", function () {
      api.rerender('297eaffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/TicketDetail.vue"
export default component.exports